import { useInterpret } from '@xstate/react'
import * as React from 'react'
import { ContextFrom, InterpreterFrom } from 'xstate'

import { TLanguage } from '~config/locales'
import { createContext } from '~logic/lib/react'

import { authMachine } from '../service/authMachine'
import { useFetchTokenServices } from '../utils/useFetchTokenServices'

type TContext = ContextFrom<typeof authMachine>
type TService = InterpreterFrom<typeof authMachine>

type TProps = RequiredChildren & {
  backendUrl: string
  activeLocale: TLanguage['code']
  initContext: () => Promise<TContext | null>
  onContextChange: (value: TContext) => void
}

const [Provider, useAuthMachineCtx] = createContext<TService>('Auth')

/**
 * renders the provider of the auth machine instance
 */
export const AuthMachineProvider: React.FC<TProps> = ({
  backendUrl,
  children,
  onContextChange,
  initContext,
  activeLocale,
}) => {
  const { obtainGuestToken, obtainUserToken } = useFetchTokenServices({
    backendUrl,
    locale: activeLocale,
  })

  const service = useInterpret(authMachine, {
    services: {
      initContext,
      obtainUserToken,
      obtainGuestToken,
    },
    actions: { onContextChange },
  })

  return <Provider value={service}>{children}</Provider>
}

export { useAuthMachineCtx }
